export const LABEL_SIZE = {
    BIG: 'big',
    MEDIUM: 'medium',
    SMALL: 'small',
};
export const STATIC_LABEL_COLORS = {
    STATIC_0: 'static_0',
    STATIC_1: 'static_1',
    STATIC_2: 'static_2',
    STATIC_3: 'static_3',
    STATIC_4: 'static_4',
    STATIC_5: 'static_5',
    STATIC_6: 'static_6',
    STATIC_INFO: 'static_info',
    STATIC_ERROR: 'static_error',
    STATIC_ALERT: 'static_alert',
    STATIC_SUCCESS: 'static_success',
};
export const LABEL_COLORS_COUNT = 6;
